import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.js";
import "./styles.css";
// Importing @viz/widgets has the side effect of registering all bundled widgets
// in the presentation registry. We don't use the registry yet (we render
// widgets directly), but the import keeps the option open and pulls the
// vendored package into the bundle for tree-shaking analysis.
import "@viz/widgets";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
